// extracted by mini-css-extract-plugin
export default {"box":"settings_box__rNebg","mobileBox":"settings_mobileBox__oZDPd","colorPickerOverlayBg":"settings_colorPickerOverlayBg__5oGOW"};